const Footer = () => {
    return (
        <footer className="footer mt-auto py-3 bg-dark">
            <div className="container">
                <p className="text-light">App develop by <a href="https://github.com/SergioRuyDev" target="_blank" rel="noreferrer">Sergio Ruy</a></p>
                <p className="text-light">Access my <a href="https://www.linkedin.com/in/sergioruy/" target="_blank" rel="noreferrer">Linkedin</a></p>
            </div>
        </footer>

    );
}

export default Footer;
